import * as htmlParser from './htmlParser';
import { EventData, ScrapeOptions } from './types';
import axios, { AxiosProxyConfig } from 'axios';

const scrape = async (dataString: string): Promise<EventData> => {
	// NOTE: If we want to pick up mutli-date events (technically this is just multiple events linked together), we can look at the comet_neighboring_siblings key

	const { id, name, photo, video, isOnline, url, startTimestamp, formattedDate, siblingEvents, parentEvent } = htmlParser.getBasicData(dataString);
	const { endTimestamp, timezone } = htmlParser.getEndTimestampAndTimezone(dataString, startTimestamp);

	let location = null;
	let onlineDetails = null;
	if (isOnline) {
		onlineDetails = htmlParser.getOnlineDetails(dataString);
	} else {
		location = htmlParser.getLocation(dataString);
	}

	const description = htmlParser.getDescription(dataString);
	const ticketUrl = htmlParser.getTicketUrl(dataString);

	const categories = htmlParser.getCategories(dataString);

	const hosts = htmlParser.getHosts(dataString);
	const { usersResponded } = htmlParser.getUserStats(dataString);

	return {
		id,
		name,
		description,
		location,
		photo,
		video,
		isOnline,
		url,
		startTimestamp,
		endTimestamp,
		formattedDate,
		timezone,
		onlineDetails,
		hosts,
		ticketUrl,
		categories,
		siblingEvents,
		parentEvent,
		usersResponded,
	};
};

export const scrapeEvent = async (urlFromUser: string, options: ScrapeOptions): Promise<EventData> => {
	const dataString = await fetchEvent(urlFromUser, options.proxy);
    return scrape(dataString);
};

export const scrapeEventFromHtml = async (html: string): Promise<EventData> => {
    return scrape(html);
};

export const fetchEvent = async (url: string, proxy?: AxiosProxyConfig) => {
	try {
		const response = await axios.get(url, {
			headers: {
				accept: '*/*', // 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,* /*;q=0.8',
				//'accept-language': 'en-US,en;q=0.6',
				'cache-control': 'no-cache',
				'access-control-allow-origin': 'http://localhost',
				// NOTE: Need these headers to get all the event data, some combo of the sec fetch headers
				//'upgrade-insecure-requests': '1',
				'accept-encoding': 'gzip, deflate, br',
				/*'sec-fetch-dest': 'document',
				'sec-fetch-mode': 'navigate',
				'sec-fetch-site': 'same-origin',
				'sec-fetch-user': '?1',
				'sec-gpc': '1',
				'user-agent':
					'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/109.0.0.0 Safari/537.36',*/
			},
			proxy,
		});

		return response.data;
	} catch (err: any) {
		// TODO: if in debug, print error: err.response?.data ?? err
		throw new Error(
			'Error fetching event, make sure your URL is correct and the event is accessible to the public.'
		);
	}
};

export const fbidToUrl = (fbid: string) => {
	if (!fbid.match(/^[0-9]{8,}$/)) {
		throw new Error('Invalid FB ID');
	}

	return `https://www.facebook.com/events/${fbid}?_fb_noscript=1`;
};

export const validateAndFormatUrl = (url: string) => {
	const fbid = url.match(/facebook\.com\/events\/(?:.+\/.+\/)?([0-9]{8,})/)?.[1];

	if (!fbid) {
		throw new Error('Invalid Facebook event URL');
	}

	return `https://www.facebook.com/events/${fbid}?_fb_noscript=1`;
};
